import { getQueryParamCaseInsensitive, httpUtilityUrlEncode } from '@/features/shared/queryParams';

const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function buildIncidentListOpenNewIncidentDialogUrl(
  searchParams: URLSearchParams,
  newGuid: () => string = () => crypto.randomUUID(),
): string {
  const requestedIncidentIdParam = getQueryParamCaseInsensitive(searchParams, 'requestedIncidentId');
  const incidentId =
    requestedIncidentIdParam !== null && GUID_PATTERN.test(requestedIncidentIdParam)
      ? requestedIncidentIdParam.toLowerCase()
      : newGuid();

  const phoneNumber = getQueryParamCaseInsensitive(searchParams, 'phoneNumber') ?? '';

  return `/incident-list?requestedIncidentId=${incidentId}&phoneNumber=${httpUtilityUrlEncode(phoneNumber)}`;
}
